import { CompanyData } from './../../../types/constants';

import epigroBg from './../../../assets/img/epigro_bg.jpg';
import { projects } from './projects';

export const epigro: CompanyData = {
  id: 4,
  name: 'Epigro Pvt Ltd',
  country: 'Sri Lanka',
  bg: epigroBg,
  position: 'Trainee Software Engineer',
  time: 'Mar 2016 - Sep 2016 (7 Months)',
  description:
    'Epigro is a comprehensive solar developer that handles the whole process of going solar from beginning to end. I have worked as a Trainee Software Engineer with Epigro',
  projects: projects,
};
